module.exports = __webpack_public_path__ + "img/17_33.8bed5f3b.png";